@if (headline.length > 0) {
    <p class="headline"
       [ngClass]="{'last-element': !content.children.length}">{{headline}}</p>
}

<div class="content" #content>
    <ng-content />
</div>
